// Issue #13241: 見学候補日の「終日」操作の共通ロジック。
// datetime-local の開始入力に <日付>T00:00、終了入力に <日付>T23:59 を設定する。
// モーダル行（tour_plan_dates コントローラ）と一括反映行（round_block コントローラ）で共用する。

// datetime-local の値（YYYY-MM-DDTHH:MM）から日付部分（YYYY-MM-DD）を取り出す。
function datePart (value) {
  if (!value) return null
  const separatorIndex = value.indexOf('T')
  return separatorIndex === -1 ? value : value.slice(0, separatorIndex)
}

// 「終日」チェック時に開始 00:00 / 終了 23:59 を設定する。
// - checked が false（チェックを外した）場合は値を変更しない（既存入力を保持）。
// - 日付が未入力の場合は時刻だけ入れても無効値になるため、何もしない。
//   日付は開始入力を優先し、未入力なら終了入力の日付を使う。
export function applyAllDay (startInput, endInput, checked) {
  if (!checked) return
  if (!startInput || !endInput) return

  const date = datePart(startInput.value) || datePart(endInput.value)
  if (!date) return

  startInput.value = `${date}T00:00`
  endInput.value = `${date}T23:59`
}
